<ng-container *ngIf="dataSource">
  <div id="maintenance-table" class="col-12 mt-2">
    <mat-accordion multi>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Détail des entretiens
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="w-100" *ngIf="dataSource.data.length > 0; else noData">
          <div class="d-flex flex-column flex-sm-row">
            <mat-form-field>
              <mat-icon matPrefix color="primary">search</mat-icon>
              <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Rechercher" />
            </mat-form-field>
            <mat-slide-toggle (change)="toggleDisplayColumns()" [checked]="displayFullColumns"
              class="m-3 no-mobile">Plus de
              détails</mat-slide-toggle>
          </div>
          <div [class]="tableClass">
            <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
              <ng-container matColumnDef="summary">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Résumé</th>
                <td mat-cell *matCellDef="let row" [class]="'main'+ (row.hasDone ? ' clickable' : '')"
                  (click)="expandedElement = !row.hasDone || expandedElement === row ? null : row">{{
                  row.summary }}
                </td>
              </ng-container>
              <ng-container matColumnDef="frequency">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Fréquence</th>
                <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.frequency }}</td>
              </ng-container>
              <ng-container matColumnDef="lastDoneDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Effectué le</th>
                <td mat-cell *matCellDef="let row" class="no-mobile">{{ row.lastDoneDate ?
                  (row.lastDoneDate |
                  dateFormat) : 'Jamais' }}</td>
              </ng-container>
              <ng-container matColumnDef="toDoDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>A faire pour le</th>
                <td mat-cell *matCellDef="let row">
                  <mat-icon *ngIf="row.isTodo" class="" color="warn"
                    appTooltip="L'entretien est à effectuer">error</mat-icon>
                  <span>{{ row.toDoDate ?
                    (row.toDoDate |
                    dateFormat) : 'au plus tôt' }}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
                <td mat-cell *matCellDef="let row">{{ row.type }}</td>
              </ng-container>
              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
                <td mat-cell *matCellDef="let row" class="no-mobile">{{ row.description }}</td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Actions</th>
                <td mat-cell *matCellDef="let row" class="mobile-double-actions">
                  <button class="mobile-inline" mat-icon-button (click)="addDone(row.maintenance)"
                    appTooltip="Effectuer l'entretien"><mat-icon color="primary">task_alt</mat-icon></button>
                  <button mat-icon-button [matMenuTriggerFor]="actions"
                    [style]="canUpdateProperty ? '' : 'visibility: hidden'" [matMenuTriggerData]="{data:row}">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                  <div class="element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                    <ul>
                      <li *ngFor="let done of element.maintenance.dones">
                        <span>Effectué le {{ done.date | dateFormat }}</span>
                        <span *ngIf="done.company">, par l'entreprise <i>{{ done.company }}</i></span>
                        <span *ngIf="done.cost"> - Coût {{ done.cost | decimalFormat }} €</span>
                        <span *ngIf="done.comments"> - {{ done.comments }}</span>
                        <button *ngIf="canUpdateProperty" mat-icon-button color="primary"
                          (click)="confirmDeleteDone(element, done)" appTooltip="Supprimer l'entretien effectué">
                          <mat-icon aria-label="Supprimer l'entretien effectué">delete_forever</mat-icon>
                        </button>
                      </li>
                    </ul>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.expanded-row]="expandedElement === row"
                class="with-detail theme-1"></tr>
              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" [appDetailRow]="'SELECT'"></tr>
            </table>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <ng-template #noData>
    <span class="no-content dark">Aucun type d'entretien n'est renseigné</span>
  </ng-template>
</ng-container>

<mat-menu #actions="matMenu">
  <ng-template matMenuContent let-row="data">
    <ul class="menu-actions">
      <li *ngIf="row.hasDone">
        <a (click)="expandedElement = expandedElement === row ? null : row"><mat-icon
            color="primary">remove_red_eye</mat-icon><span class="text">Voir les entretiens effectués</span></a>
      </li>
      <li>
        <a (click)="edit(row.maintenance)"><mat-icon color="primary">create</mat-icon><span class="text">Modifier
            l'entretien</span></a>
      </li>
      <li>
        <a (click)="confirmDelete(row.maintenance)">
          <mat-icon color="primary">delete_forever</mat-icon>
          <span class="text">Supprimer l'entretien</span>
        </a>
      </li>
    </ul>
  </ng-template>
</mat-menu>

<div class="col-12 mt-2">
  <app-property-doc-view *ngIf="rawData" [prop]="prop" [category]="category"
    [maintenances]="rawData"></app-property-doc-view>
</div>
